import './page/suggestion-list';
import './component/suggestion-form';

const { Module } = Shopware;

Module.register('topdata-es-synonym-suggestion', {
    type: 'plugin',
    name: 'SynonymSuggestion',
    title: 'TopdataEnhancedSearchSW6.topdata-es-synonym-suggestion.general.mainMenuItem',
    description: 'TopdataEnhancedSearchSW6.topdata-es-synonym-suggestion.general.descriptionText',
    color: '#37d6c1',
    icon: 'default-object-thumbnail',

    routes: {
        list: {
            component: 'topdata-es-synonym-suggestion-list',
            path: 'list',
            meta: {
                privilege: 'system.synonym_suggestion.viewer',
            },
        },
    },

    navigation: [{
        id: 'topdata-es-synonym-suggestion',
        parent: 'topdata-es',
        label: 'TopdataEnhancedSearchSW6.topdata-es-synonym-suggestion.general.mainMenuItem',
        path: 'topdata.es.synonym.suggestion.list',
        icon: 'default-object-thumbnail',
        privilege: 'system.synonym_suggestion.viewer',
    }],
});
